<div class="popup-container">

<header>
  <label class="close_button" (click)="close()">x</label>
  <div class="header d-block roboto-medium">
    <label class="ms-3 mt-3 mb-3">{{ heading }}</label>
  </div>
</header>

<div
  class="body"
  [style]="errormsg ? 'margin: 1% 2% 0% 2%;' : 'margin: 1% 2% 2% 2%;'"
>
  <div class="row">
    <div class="col-6">
      <div>
        <label class="catlabel cat_head">Domicile :</label>
        <span class="content">
          {{ domicile }}
        </span>
      </div>
    </div>
    <div class="col-6">
      <div>
        <label class="catlabel cat_head">Update Trigger : </label>
        <span class="content">
          <input
            type="number"
            step="10"
            min="0"
            class="category cat_style"
            [(ngModel)]="updateTrigger"
          />
        </span>
      </div>
    </div>
    <div class="col-6">
      <div>
        <label class="catlabel cat_head">Red Trigger : </label>
        <span class="content">
          <input
            type="number"
            step="10"
            min="0"
            class="category cat_style"
            [(ngModel)]="redTrigger"
          />
        </span>
      </div>
    </div>
    <div class="col-6">
      <div>
        <label class="catlabel cat_head">Yellow Trigger : </label>
        <span class="content">
          <input
            type="number"
            step="10"
            min="0"
            class="category cat_style"
            [(ngModel)]="yellowTrigger"
          />
        </span>
      </div>
    </div>
    <div class="col-6">
      <div>
        <label class="catlabel cat_head">Snooze Delay : </label>
        <span class="content">
          <input
            type="number"
            step="10"
            min="0"
            class="category cat_style"
            [(ngModel)]="snoozeDelay"
          />
        </span>
      </div>
    </div>
  </div>
</div>
<label *ngIf="errormsg" class="errormsg"> {{ errormsg }} </label>
<div
  class="
    footer
    d-flex
    justify-content-end
    align-items-center
    fixed-bottom
    mt-2
    pt-2
    pb-2
  "
>
  <button class="cancel me-3 roboto-bold" (click)="close()">CANCEL</button>
  <button class="submit black-button me-3 roboto-bold" (click)="saveClick()">
    UPDATE
  </button>
</div>
</div>
